import { render } from "./AddCasier.vue?vue&type=template&id=1b970d29&ts=true"
import script from "./AddCasier.vue?vue&type=script&lang=ts"
export * from "./AddCasier.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__